module.exports = __webpack_public_path__ + "static/media/education.b22fad4b.svg";